var exports = {
  "k": "xe533113f--6fbce0--container",
  "i": "xe533113f--6fbce0--wrapper",
};

module.exports = exports;
